/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/077-map2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M10.5 3l-5-2L0 3v12l5.5-2 5 2 5.5-2V1l-5.5 2zM6 2.277l4 1.6v9.846l-4-1.6V2.277zM1 3.7l4-1.455v9.872l-4 1.454V3.699zm14 8.6l-4 1.455V3.883l4-1.455V12.3z"/>'
  }
})
